const normalizedContains = (needle: string, haystack: any) => {
    const normalizedNeedle = removeDiacritics(String(needle).trim()).toLowerCase();

    const targetText = typeof haystack === 'string' ? haystack : Object.values(haystack).join(' ');

    const target = removeDiacritics(String(targetText)).toLowerCase();
    const tokens = normalizedNeedle.split(/\s+/).filter(Boolean);

    return tokens.every(t => target.includes(t));
};

const removeDiacritics = (text: string) => {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

const filterNormalizeOptions = (options: any[], searchText: string) => {
    const filteredOptions = searchText
        ? options.filter((option: any) => normalizedContains(searchText, option))
        : options;

    return filteredOptions;
};

export default filterNormalizeOptions;
